/**
 * c-size-guide-modal.js
 *
 * 校正対応 2026-05-24 (商品詳細 動作不具合 / 追加発覚分):
 *   サイズ切替後 (Dawn variant 切替 / section render API) にサイズガイドモーダルが開かない不具合。
 *
 * 旧実装の問題:
 *   snippets/c-product-variant-picker.liquid 内インラインスクリプトで初期 1 回のみ実行され、
 *   modal を body 直下に portal + listener 登録していた。
 *   variant 切替で product__info 内に新 modal が再生成されるが、新 modal は portal も
 *   listener も再実行されないため、サイズガイドボタンを押しても modal が開かない。
 *   旧 modal は body 直下に残ったままで、新 modal と ID 重複も発生していた。
 *
 * 修正方針:
 *   MutationObserver で document.body subtree を継続監視。新 modal 検出時に
 *   1. 同 ID の旧 modal (body 直下) を削除
 *   2. 新 modal を body 直下に portal
 *   3. open/close listener を bind
 *   4. open button (variant picker 内) にも click listener を bind
 *   modal[data-c-init="1"] + button[data-c-size-guide-open-init="1"] フラグで二重 bind 防止。
 *   Escape キー listener は document に 1 回だけ登録 (キー押下時に表示中 modal を全 close)。
 */
(function () {
  var MODAL_SELECTOR = '.c-size-guide-modal';
  var OPEN_BTN_SELECTOR = '[data-c-size-guide-open]';
  var INIT_FLAG_ATTR = 'cInit';
  var OPEN_BTN_FLAG_ATTR = 'cSizeGuideOpenInit';

  function bindModal(modal) {
    if (modal.dataset[INIT_FLAG_ATTR] === '1') return;
    modal.dataset[INIT_FLAG_ATTR] = '1';

    /* PM 0507 #4: スライドインアニメ
       open  = hidden 削除 → 次フレームで is-open 追加 → transform 0.35s 発動
       close = is-open 削除 → 350ms 後に hidden 追加 (アニメ完了後に display:none) */
    function open() {
      modal.removeAttribute('hidden');
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        modal.classList.add('is-open');
      });
    }
    function close() {
      modal.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(function () {
        modal.setAttribute('hidden', '');
      }, 350);
    }
    modal._cSizeGuideOpen = open;
    modal._cSizeGuideClose = close;

    modal.querySelectorAll('[data-c-size-guide-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
  }

  function bindOpenButtons() {
    document.querySelectorAll(OPEN_BTN_SELECTOR).forEach(function (btn) {
      if (btn.dataset[OPEN_BTN_FLAG_ATTR] === '1') return;
      var modalId = btn.getAttribute('data-c-size-guide-open');
      var modal = document.getElementById(modalId);
      if (!modal || !modal._cSizeGuideOpen) return;
      btn.dataset[OPEN_BTN_FLAG_ATTR] = '1';
      btn.addEventListener('click', modal._cSizeGuideOpen);
    });
  }

  function applyAll() {
    document.querySelectorAll(MODAL_SELECTOR).forEach(function (modal) {
      /* 既に portal + bind 済 (body 直下 / init flag) なら skip */
      if (modal.dataset[INIT_FLAG_ATTR] === '1' && modal.parentNode === document.body) return;

      var modalId = modal.id;

      /* 同 ID の旧 modal (body 直下) を削除 → variant 切替で生成された新 modal で置換 */
      if (modalId) {
        document.querySelectorAll(MODAL_SELECTOR + '[id="' + modalId + '"]').forEach(function (oldModal) {
          if (oldModal !== modal && oldModal.parentNode === document.body) {
            oldModal.parentNode.removeChild(oldModal);
          }
        });
      }

      /* 新 modal を body 直下に portal */
      if (modal.parentNode !== document.body) {
        document.body.appendChild(modal);
      }

      bindModal(modal);
    });

    bindOpenButtons();
  }

  /* Escape キー listener は document に 1 回だけ登録 */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll(MODAL_SELECTOR + ':not([hidden])').forEach(function (modal) {
      if (modal._cSizeGuideClose) modal._cSizeGuideClose();
    });
  });

  function setup() {
    applyAll();

    if (window.MutationObserver && document.body) {
      var scheduled = false;
      var observer = new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        (window.requestAnimationFrame || setTimeout)(function () {
          scheduled = false;
          applyAll();
        }, 0);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
